import { render } from "./EmpresasUros.vue?vue&type=template&id=383188b5"
import script from "./EmpresasUros.vue?vue&type=script&lang=js"
export * from "./EmpresasUros.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__